import { devices } from '@helpers/utils.js';
import {
  MediaReplaceButton,
  MediaRemoveButton,
} from '@components/media-upload';

const {
  i18n: { __ },
  blockEditor: { MediaUpload, MediaUploadCheck },
  components: { PanelBody, Button },
} = wp;

const BackgroundTypeImage = ({ backgroundImageOptions, setAttributes }) => {
  const changeBackgroundImage = (
    paramSectionImgId,
    paramSectionImgUrl,
    paramSectionImgAlt,
    paramDeviceType,
    paramBackgroundImageOptions,
  ) => {
    setAttributes({
      backgroundImageOptions: {
        ...paramBackgroundImageOptions,
        [paramDeviceType]: {
          ...backgroundImageOptions[paramDeviceType],
          settings: {
            ...paramBackgroundImageOptions[paramDeviceType].settings,
            sectionImgId: paramSectionImgId,
            sectionImgUrl: paramSectionImgUrl,
            sectionImgAlt: paramSectionImgAlt,
          },
        },
      },
    });
  };

  return (
    <>
      {devices.map((device, index) => {
        const deviceType = device.type;
        const deviceLabel = device.label;
        const { sectionImgUrl, sectionImgId } =
          backgroundImageOptions[deviceType].settings;

        return (
          <PanelBody
            title={deviceLabel}
            initialOpen={index === 0}
            key={deviceType}
          >
            <MediaUploadCheck>
              <MediaUpload
                allowedType={['image']}
                value={sectionImgId}
                onSelect={(img) => {
                  const {
                    id: sectionImgIdOnSelect = '',
                    url: sectionImgUrlOnSelect = '',
                    alt: sectionImgAltOnSelect = '',
                  } = img;
                  changeBackgroundImage(
                    sectionImgIdOnSelect,
                    sectionImgUrlOnSelect,
                    sectionImgAltOnSelect,
                    deviceType,
                    backgroundImageOptions,
                  );
                }}
                render={({ open }) => (
                  <div className="media-upload image-upload">
                    {sectionImgUrl && (
                      <div className="upload-buttons-wrapper">
                        <MediaReplaceButton onClick={open} />
                        <MediaRemoveButton
                          onClick={() => {
                            changeBackgroundImage(
                              '',
                              '',
                              '',
                              deviceType,
                              backgroundImageOptions,
                            );
                          }}
                        />
                      </div>
                    )}
                    {!sectionImgUrl && (
                      <Button
                        className="media-button upload-button"
                        onClick={open}
                      >
                        {__('Upload Image', 'b3rg')}
                      </Button>
                    )}
                    {sectionImgUrl && (
                      <div
                        className="image-thumb-wrapper"
                        onClick={open}
                        onKeyUp={open}
                        role="button"
                        tabIndex="0"
                      >
                        <img
                          className="image-thumb"
                          src={sectionImgUrl}
                          alt={sectionImgId}
                        />
                      </div>
                    )}
                  </div>
                )}
              ></MediaUpload>
            </MediaUploadCheck>
          </PanelBody>
        );
      })}
    </>
  );
};

export default BackgroundTypeImage;
